import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PortalService } from '@core/home/portal.service';

@Component({
    selector: 'sume-processo-guia',
    templateUrl: './processo-guia.component.html',
})
export class ProcessoGuiaComponent implements OnInit {
    @Input() idProcesso: number;
    @Input() idMacroProcesso = 0;
    pathProcessoPage;
    queryParams;
    role = this.portalService.getRole().toLowerCase();
    constructor(private router: Router, private portalService: PortalService) {}

    ngOnInit() {
        this.setPath();
    }

    setPath() {
        let path, queryParams;

        if (this.idMacroProcesso != 0) {
            path = `/${this.role}/conhecimento/dominios/0/macroprocessos/${this.idMacroProcesso}/processos`;
            queryParams = {};
        } else {
            path = `/${this.role}/conhecimento/dominios/0/macroprocessos/0/processos`;
            queryParams = { id_processo: this.idProcesso };
        }

        this.pathProcessoPage = path;
        this.queryParams = queryParams;
    }
}
